import Layout from '@/layout/index.vue';

export default [
  {
    path: '/article',
    name: 'article',
    component: Layout,
    redirect: '/article/list',
    meta: {
      title: '官网文章管理',
    },
    children: [
      {
        path: '/article/list',
        name: 'articleList',
        component: () => import('@/views/article/pages/list/index.vue'),
        meta: {
          title: '文章列表',
          newPage: true,
        },
      },
    ],
  },
];
